"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.closestMatch = exports.distance = void 0;
var distance_1 = require("./methods/distance");
var closestMatch_1 = require("./methods/closestMatch");
exports.distance = distance_1.distance;
exports.closestMatch = closestMatch_1.closestMatch;
